// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');

// @ utils
const { formatAmount } = require('utilities/currencyHelper');
const { VALUE_TYPES } = require('../../../insuranceConstants/insuranceRequestHome');

// @ utils
const { getLanguage } = require('core/i18n').i18n;

// @ constants
const { EURO_SYMBOL } = require('constants/index');

const InsuranceRequestPlansRowValue = props => {
    const {
        insuranceUsabilityImprovementsFlag,
        type,
        value,
    } = props;

    const language = getLanguage();
    let rowValue = (
        <div className="coverage-and-plans__icon-container">
            <span className="icon-cerrar coverage-and-plans__icon-close" />
        </div>
    );

    const iconCheckedRowClasses = classnames('coverage-and-plans__icon-checked', {
        'coverage-and-plans__icon-checked--inline': insuranceUsabilityImprovementsFlag
    });

    if (type === VALUE_TYPES.CHECK) {
        if (value === '1') {
            rowValue = (
                <div className="coverage-and-plans__icon-container">
                    <span className="coverage-and-plans__icon-checked" />
                </div>
            );
        }
        else if (value === '2') {
            rowValue = (
                <div className="coverage-and-plans__icon-container">
                    <span className={iconCheckedRowClasses} />
                    <span className={iconCheckedRowClasses} />
                </div>
            );
        }
    } else if (type === VALUE_TYPES.NUMBER) {
        rowValue = <span className="coverage-and-plans__total-value">{value}</span>;
    } else {
        const totalValue = `${formatAmount(value, language, 0)} ${EURO_SYMBOL}`;
        rowValue = <span className="coverage-and-plans__total-value">{totalValue}</span>;
    }

    return rowValue;
};

InsuranceRequestPlansRowValue.propTypes = {
    insuranceUsabilityImprovementsFlag: PropTypes.bool.isRequired,
    type: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
};

module.exports = InsuranceRequestPlansRowValue;
